module.exports = __webpack_public_path__ + "img/brunnings-logo.0a24067e.png";